enum MATERIAL_ACTIONS {
  FETCH_MATERIAL = 'FETCH_MATERIAL',
  FETCH_MATERIAL_START = 'FETCH_MATERIAL_START',
  FETCH_MATERIAL_FINISH = 'FETCH_MATERIAL_FINISH',
  FETCH_SIDE_MENU = 'FETCH_SIDE_MENU',
  FETCH_SIDE_MENU_START = 'FETCH_SIDE_MENU_START',
  FETCH_SIDE_MENU_FINISH = 'FETCH_SIDE_MENU_FINISH',
  CLEAR_MATERIAL_DETAILS = 'CLEAR_MATERIAL_DETAILS',
  FETCH_MATERIAL_BASE64 = 'FETCH_MATERIAL_BASE64',
  FETCH_MATERIAL_BASE64_START = 'FETCH_MATERIAL_BASE64_START',
  FETCH_MATERIAL_BASE64_FINISH = 'FETCH_MATERIAL_BASE64_FINISH',
}
export default MATERIAL_ACTIONS;
